import React from 'react'
import BackgroundVideo from '../general/BackgroundVideo'

// const handleKeyDown= (event) => {
//     console.log('key down', event.key)
//     if(event  && event.key === "Enter")  {

//         event.preventDefault()
//         return false
//     }

// }



const PageLogin = ({
    userName, 
    userPassword, 
    takeOverSession, 
    errorMessage, 
    handleSubmitSession,
    handleSubmitBypass,

    // handleSubmit, 
    // handleSubmitObserver,
    handleSubmitForce, 
    handleCancelForce,
    handleKeyDown,
    handleChangeUserName, 
    handleChangeUserPass, 
    userNamePlaceholder, 
    passwordPlaceholder, 
    submitButtonText,
    bypassText,
    cancelButtonText,
    forceSessionText
}) => {

    return (
        <div className="login-container">
            <div className="logo-wrapper">
                <div className="logo"></div>
            </div>
          
            <BackgroundVideo />

            <div className="login-elements-wrapper">
                <form className="login-elements">
                    {!takeOverSession && 
                        <>
                            <div className="input-field-wrapper user">
                                <input className="input-field text-light" type="text" value={userName} placeholder={userNamePlaceholder} onChange={handleChangeUserName} onKeyDown={handleKeyDown}/>
                                <span className="underline"></span>
                            </div>
                            <div className="input-field-wrapper password">
                                <input className="input-field text-light" type="password" value={userPassword} placeholder={passwordPlaceholder} onChange={handleChangeUserPass} onKeyDown={handleKeyDown}/>
                                <span className="underline"></span>
                            </div>
                        </>
                    }

                    {errorMessage && <div className="error text-light">{errorMessage}</div>}

                    {takeOverSession ? (
                        <>
                            <input name="force" className="button button-login text-light" type="submit" value={forceSessionText} onClick={(event) => handleSubmitForce(event)}/>
                            <input name="cancel" className="button button-login button-login-sec text-light" type="submit" value={cancelButtonText} onClick={(event) => handleCancelForce(event)}/>
                        </>
                    ): (
                        <>
                            <button className="button button-login text-light" type="submit" onClick={(event) => handleSubmitSession(event)}>{submitButtonText}</button>
                            <button className="button button-login button-login-sec text-light" type="submit" onClick={(event) => handleSubmitBypass(event)}>{submitButtonText}<span className="text-small-light">{`(${bypassText})`}</span></button>
                        </>
                    )}
                </form>
            </div>
        </div>
    )
}

export default PageLogin